/* jshint esversion:6*/
class CustomModule {
	constructor(AppWeb = null){
		this.AppWeb = AppWeb;
	}

	toggleContact() {
		if($('.mobile-menu').is(':visible')) {
			$('.mobile-menu').css('visibility', 'hidden');
			$('.mobile-menu').css('display', 'none');
		}
		$('#registerSuperBlock').css('visibility', 'visible');
		$('#registerSuperBlock').slideToggle('slow','swing');

		if($('.c-hamburger--rot').hasClass("is-active")) {
			$('.c-hamburger--rot').removeClass("is-active");
		}
		else {
			$('.c-hamburger--rot').addClass('is-active');
		}
	}

	showBlockTags() {
		$( "#tabs" ).tabs();
		$( "#tabs2" ).tabs();
		$( "#tabs3" ).tabs();
	}

	toogleCaptation1() {
			$('.consultin1').css('visibility', 'visible');
			$('.consultin1').slideToggle('slow','swing');
	}

	toogleCaptation2() {
		$('.consultin2').css('visibility', 'visible');
		$('.consultin2').slideToggle('slow','swing');
	}

	toogleCaptation3() {
		$('.consultin3').css('visibility', 'visible');
		$('.consultin3').slideToggle('slow','swing');
	}

	toogleFooter() {
		$('#footer-explain').css('visibility', 'visible');
		$('#footer-explain').slideToggle('slow', 'swing');
	}
	toogleToWhoare() {
			$('#footer-explain').css('visibility', 'visible');
			$('#footer-explain').slideToggle('slow', 'swing');
			$('html, body').animate({
	    scrollTop: $("#whoarewe").offset().top - 180 }, 'slow');
			$('#whoarewe').focus();
	}
	toogleToWhatwe() {
		$('#footer-explain').css('visibility', 'visible');
		$('#footer-explain').slideToggle('slow', 'swing');
		$('html, body').animate({
    scrollTop: $("#whatwedo").offset().top - 80 }, 'slow');
		$('#whoarewe').focus();
	}
	toogleToHowwe() {
		$('#footer-explain').css('visibility', 'visible');
		$('#footer-explain').slideToggle('slow', 'swing');
		$('html, body').animate({
    scrollTop: $("#howwedo").offset().top -80 }, 'slow');
		$('#whoarewe').focus();
	}
	toogleVision() {
		$('#footer-explain-vision').css('visibility', 'visible');
		$('#footer-explain-vision').slideToggle('slow', 'swing');

		$('html, body').animate({
    scrollTop: $("#footer-explain-vision").offset().top -80 }, 'slow');
		$('#footer-explain-vision').focus();

	}

	closeFooter() {
		$('#footer-explain').slideUp('slow', 'swing');
	}
	closeVision() {
		$('#footer-explain-vision').slideUp('slow', 'swing');
	}

	closeContact() {
		$('#footer-contact').slideUp('slow', 'swing');

/*
		if() {

		}
		*/

		if($('.c-hamburger--rot').hasClass("is-active")) {
			$('.c-hamburger--rot').removeClass("is-active");
			console.log("Remove");
		}
		else {
			$('.c-hamburger--rot').addClass('is-active');
			console.log("Inactive	");
		}
	}

	toogleContact2() {
		$('#footer-contact').css('visibility', 'visible');
		$('#footer-contact').slideToggle('slow', 'swing');

		if($('.mobile-menu').is(':visible')) {
			$('.mobile-menu').css('visibility', 'hidden');
			$('.mobile-menu').css('display', 'none');
		}
		else {
			$('.mobile-menu').css('visibility', 'visible');
			$('.mobile-menu').css('display', 'inline-block');
		}
		$("html, body").animate({
			scrollTop: $("#footer-contact").offset().top - 80}, 'slow');
		$('#footer-contact').focus();
	}


	showMyMenu() {
		if($('#footer-contact').css('display') == 'inline-block') {
				$('#footer-contact').css('display', 'none');
				$('#footer-contact').css('visibility', 'hidden');

				if($('.c-hamburger--rot').hasClass("is-active")) {
					$('.c-hamburger--rot').removeClass("is-active");
				}
				else {
					$('.c-hamburger--rot').addClass('is-active');
				}

			console.log("Displaying in block");
		}
		else {
			$('#footer-contact').css('visibility', 'visible');
			$('#footer-contact').slideToggle('slow', 'swing');


			if($('.c-hamburger--rot').hasClass("is-active")) {
				$('.c-hamburger--rot').removeClass("is-active");
			}
			else {
				$('.c-hamburger--rot').addClass('is-active');
			}
		}

	}

	check_captcha() {
		var v = grecaptcha.getResponse();
    if(v.length == 0)
    {
        document.getElementById('captcha').innerHTML="You can't leave Captcha Code empty";
        return false;
    }
	}

	bindAll(context){
		$('#web-message [role=close]').on('click', function(){
			$('#web-message').remove();
		});

		web.custom.showBlockTags();
	}

}

module.exports = CustomModule;



// WEBPACK FOOTER //
// ./C:/wamp64/www/cig-landing/devel/js/custom.js